// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import logo from '@/assets/logo.png';
import { useCurrentUser } from '@/authentication/hooks/use-current-user';
import { useLogout } from '@/authentication/hooks/use-logout';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Link,
  Stack,
  Typography,
} from '@mui/material';

const SUPPORT_EMAIL = 'support@hardfin.com';

/**
 * The only page an organization sees once its access has ended. It fetches
 * nothing and offers no navigation, because every other API call is rejected
 * while the organization is locked out.
 */
export function AccessEndedPage() {
  const { user } = useCurrentUser();
  const logout = useLogout();

  const handleClickLogout = () => {
    void logout();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="grey.50"
      width="100dvw"
      height="100dvh"
    >
      <Container component="main" maxWidth="sm">
        <Stack spacing={3} alignItems="center">
          <img alt="logo" src={logo} height="40px" width="auto" />
          <Alert severity="warning" sx={{ width: '100%' }}>
            <AlertTitle>
              Access has ended for the {user.organization.name} organization
            </AlertTitle>
            <Stack spacing={1}>
              <Typography variant="body2">
                Your organization&apos;s audit data will be retained for 365
                days after your subscription end date.
              </Typography>
              <Typography variant="body2">
                Data can be restored if you choose to renew before that date.
                After that date, your organization data will be lost.
              </Typography>
              <Typography variant="body2">
                Contact{' '}
                <Link href={`mailto:${SUPPORT_EMAIL}`} color="inherit">
                  Hardfin support
                </Link>{' '}
                to have your data removed earlier.
              </Typography>
            </Stack>
          </Alert>
          <Button size="small" variant="outlined" onClick={handleClickLogout}>
            Log out
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
